import { render, staticRenderFns } from "./Pdv.vue?vue&type=template&id=28d2aef4&scoped=true&"
import script from "./Pdv.vue?vue&type=script&lang=ts&"
export * from "./Pdv.vue?vue&type=script&lang=ts&"
import style0 from "./Pdv.vue?vue&type=style&index=0&id=28d2aef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2aef4",
  null
  
)

export default component.exports